<eiq-card>
  <div slot="content" class="eiq-dashboard-card">
    <div class="eiq-dashboard-card__header">
      <div class="eiq-dashboard-card__header-title">
        <span class="display__xs fw__600">{{ title() }}</span>
        <span class="text__lg fw__400 caption">{{ subtitle() }}</span>
      </div>

      @if (badgeText()) {
        <eiq-badge
          data-testid="dashboard-card-status"
          [text]="badgeText()"
          [color]="badgeColor()"
          [icon]="badgeIcon()"
          [background]="'transparent'"
          [height]="'medium'"
        />
      }
    </div>

    <div class="eiq-dashboard-card__body">
      <ng-content></ng-content>
    </div>

    <eiq-break-line></eiq-break-line>

    <div class="eiq-dashboard-card__footer">
      <div class="eiq-dashboard-card__footer-owner">
        <ng-content select="[slot=owner]"></ng-content>
      </div>

      <eiq-button
        [text]="actionText()"
        [color]="'primary'"
        [style]="'stroked'"
        [icon]="faArrowRight"
        [iconPosition]="'right'"
        [testId]="testId()"
        (clicked)="open.emit()"
      />
    </div>
  </div>
</eiq-card>
